import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga';
import Helmet from 'react-helmet'
import './App.css';
import { Route, Switch, Link} from 'react-router-dom'

// Elements
import Header from './header/header'
import MainpageBody from './mainpage-body/mainpage-body'
// import Datenschutz from './datenschutz/datenschutz'
import Impressum from './impressum/impressum'
import Footer from './footer/footer'

// Globals
ReactGA.initialize('UA-114587064-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shrink: false,
            width: window.innerWidth,
            height: window.innerHeight,
            imgResIndex: 0,
            sections: ['', '', '', ''],
            links: ['', '', '', ''],
            highlightedSection: -1,
            scrollHandler: [],
        };

        this.lastScrollPos = 0;
    }

    setHeaderSections(list) {
        let sections = list;
        let links = [];
        for (let i = 0; i < sections.length; i++) {
            links.push(Header.nameToLink(sections[i]).replace('#', ''));
        }
        this.setState({links: links, sections: sections});
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize.bind(this));
        window.addEventListener("wheel", this.handleWheel.bind(this));
        window.addEventListener("scroll", this.handleScroll.bind(this));
    }

    componentDidUpdate() {
        // Do nothing for now.
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("wheel", this.handleWheel);
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleResize(e) {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
        if (window.innerWidth < 400)
            this.setState({ imgResIndex: 0 });
        else if (window.innerWidth < 600)
            this.setState({ imgResIndex: 1 });
        else if (window.innerWidth < 800)
            this.setState({ imgResIndex: 2 });
        else
            this.setState({ imgResIndex: 3 });
    }

    setShrinkStatus(pos) {
        let shrink;
        if (pos < 90) {
            shrink = false;
        }
        else if (pos > 100) {
            shrink = true;
        }

        if (shrink !== undefined && this.state.shrink !== shrink) {
            this.setState({ shrink: shrink });
        }
    }

    onPosChanged() {
        for (let i = this.state.links.length - 1; i >= 0 ; i--) {
            const element = this.state.links[i];
            this.state.scrollHandler[0]();
            console.log(element);
            let pos = ReactDOM.findDOMNode(this.refs['h1' + element]).getBoundingClientRect().y;
            if (pos < 150) {
                console.log(element + 'UPDATE');
                return;
            }
        }
    }

    getDocHeight() {
        const D = document;
        return Math.max(
            D.body.scrollHeight, D.documentElement.scrollHeight,
            D.body.offsetHeight, D.documentElement.offsetHeight,
            D.body.clientHeight, D.documentElement.clientHeight
        );
    }

    getWindowPosXY() {
        const doc = document.documentElement;
        const left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
        return [left, top];
    }

    getBottomPosition() {
        return this.getDocHeight() - window.innerHeight;
    }

    handleWheel(event) {
        const pos = this.getWindowPosXY()[1];

        this.setShrinkStatus(pos);

        if (Math.abs(pos - this.getBottomPosition()) > 5){
            this.state.scrollHandler[0]();
        }
        else {
            this.setState({
                highlightedSection: this.state.sections.length -1,
            });
        }
    }

    handleScroll(event) {
        const pos = this.getWindowPosXY()[1];
        this.setShrinkStatus(pos);

        if (Math.abs(pos - this.getBottomPosition()) > 5){
            this.state.scrollHandler[0]();
        }
        else {
            this.setState({
                highlightedSection: this.state.sections.length -1,
            });
        }
    }

    setHighlightedSection(i) {
        if (i !== this.state.highlightedSection){
            this.setState({
                highlightedSection: i,
            });
        }
    }

    render() {
        return (
            <div className="App">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Pluspunkt Musik</title>
                    <link rel="canonical" hreflang="de" href="https://pluspunkt-musik.de"/>
                    <meta
                        name="description"
                        content="Pluspunkt die Akustik Band.
                                 Mit zwei Gitarren und Ihren Stimmen rocken Diana und Florian auch Ihre Veranstaltung." />
                    <meta
                        name="keywords"
                        content="Plus, Punkt, Pluspunkt, +, ., +., Musik, Stil, Rock, Pop, Charts,
                                Gitarre, Stimme, Diana Sonntag, Florian Hofmann, Plus, Punkt, Amerbach,
                                Rögling, Nördlingen, Wemding, Donauwörth, Neuburg, Weißenburg, Treuchtlingen,
                                Wemding, Donau Ries, Coverband, Cover, Band, Duo, Akustik, Cajon, Mundharmonika,
                                Hauptseite, Datenschutz, Impressum"/>
                </Helmet>
                <Header shrink={this.state.shrink}
                    sections={this.state.sections} highlightedSection={this.state.highlightedSection}/>
                <div className="anchor" id="top" ref="h1top" style={{ top: "0px" }}></div>

                <div className="App-body">
                    <div className="App-body-content">
                        <Switch>
                            <Route exact path='/impressum'>
                                <Impressum
                                    setHeaderSections={this.setHeaderSections.bind(this)}
                                    links={this.state.links}
                                    scrollHandler = {this.state.scrollHandler}
                                    setHighlightedSection={this.setHighlightedSection.bind(this)}
                                    sections={this.state.sections}
                                />
                            </Route>
                            <Route exact path='(/|/index.html)'>
                                <MainpageBody
                                    links={this.state.links}
                                    sections={this.state.sections}
                                    imgResIndex={this.state.imgResIndex}
                                    setHeaderSections={this.setHeaderSections.bind(this)}
                                    scrollHandler = {this.state.scrollHandler}
                                    resizeScreen={this.handleResize.bind(this)}
                                    setHighlightedSection={this.setHighlightedSection.bind(this)}
                                    />
                            </Route>
                            <Route exact path='*'>
                                <div>
                                <h1>
                                    Fehler
                                </h1>
                                <p>
                                    Hoppla, da ging etwas schief.
                                    Die Seite die du suchst existiert nicht. <br/>
                                </p>
                                <p>
                                    Schau doch einfach auf unserer <Link to='/'>Hauptseite</Link> vorbei oder melde dich bei uns falls du etwas ganz bestimmtes suchst.
                                </p>
                                </div>
                            </Route>
                        </Switch>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js